//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AccountPlanMessageModal from "./account-plan-message-modal.vue";
import HandleModalShowMixin from "@Broker/@Modules/account-plan/mixins/handle-modal-show-mixin";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { getPlanDetails } from "@Shared/@Utils/utils";
import { PLAN_NAMES } from "@Shared/@Utils/constants";
import AccountPlanPerks from "../account-plan-perks.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "WelcomePlanConfirmationModal",
  components: {
    AccountPlanMessageModal,
    AccountPlanPerks,
    SimpleButton
  },
  mixins: [HandleModalShowMixin],
  computed: {
    freeAccountPlan() {
      return getPlanDetails(PLAN_NAMES.FREE);
    }
  },
  methods: {
    handleGoToAccountPlan() {
      this.computedShown = false;
      this.$router.push({
        name: "account-plan"
      });
    }
  }
});